import React, { useState } from 'react'
import axios from 'axios'
import Spinners from '../Spinners'
import { useSelector, useDispatch } from 'react-redux'
import { 
  updateInput ,   
 } from '../../../../../../features/create-company/create-company-slice'
 
const Form1 = () => {

  const [ loading, setLoading ] = useState(false)

  const { formData , errors }  = useSelector( state => state.createCompanyForm )
  const dispatch = useDispatch()
 
  const handleChange = e => {
    dispatch( updateInput({ name : e.target.name , value : e.target.value }) )
  }

 const uploadLogo = event => {
      setLoading(true)

      let _formData = new FormData();
      let company_logo = event.target.files[0]
      _formData.append('file',company_logo)
      //send request to upload image
      axios.post('http://sandboxapi.360degree.testassessify.com/company/upload-logo',_formData )
      .then( response => {
           if(response.data.success){
               dispatch( updateInput({ name : 'company_logo' , value : response.data.filePath }) )
           }
           setLoading(false)
      } )
  }

  return (
    <form>
        <h5 className='text-md font-semibold mb-4'> Step 2: Company Details </h5>
        
        <label htmlFor='name' className='text-sm'> Address: </label>
        <input 
              type='text' 
              name='address'
              className='admin-form-input'
              value={ formData.address }
              onChange = { handleChange }            
            />
          <div className='text-red-500 text-sm mt-2'> { errors.address } </div>
         <br />

        <label htmlFor='name' className='text-sm'> Business email suffix: </label>
        <input 
              type='text' 
              name='email_suffix'
              className='admin-form-input'
              value={ formData.email_suffix }
              onChange = { handleChange }  
              placeholder='E.g business.com'          
            />
          <div className='text-red-500 text-sm mt-2'> { errors.email_suffix } </div>
         <br />

        <label htmlFor='name' className='text-sm'> Business Number: </label>
        <input 
              type='number' 
              name='phone_number'
              className='admin-form-input'
              value={ formData.phone_number }
              onChange = { handleChange }      
              min = { 0 }                   
            />
         <div className='text-red-500 text-sm mt-2'> { errors.phone_number } </div>

        <div className='mt-5 text-sm'>             
            <span className='mr-2'> Note:</span>
            <i className='text-gray-700 text-xs'>Logo must be jpg or png only. max size 500px X 500px</i>
            <div className='mt-5 flex justify-between items-center'>
               {
                  //display a preview when user uplaod a logo
                  !formData.company_logo ? 
                  <span className='image-icon-wrapper'>  
                      <i className='bi bi-image text-gray-400 text-5xl'></i>
                  </span>
                  :
                  <img 
                     src={formData.company_logo} 
                     alt="company logo" 
                     className=' w-[100px] h-[90px]'
                   />
                }
                <div>
                    {
                      !loading ?
                       <>
                          <input 
                                 type='file' onChange={ uploadLogo }
                                  name='file' className='hidden' id='company_logo' 
                           />
                           <label htmlFor='company_logo' className='upload-btn mr-3'>
                               <i className='bi bi-upload text-md mr-2 '></i> Upload
                           </label>
                       </>
                       :
                        <Spinners />
                    }
                </div>
            </div>
            <div className='text-red-500 text-sm mt-2'> 
                  { formData.company_logo ? '' : errors.company_logo } 
            </div>
        </div>
    </form>
  )
}

export default Form1